module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/core-js/library/modules/$.add-to-unscopables.js
 ** module id = 32
 ** module chunks = 2
 **/